import History from '../view/checklist-item/history'
import BarChart from '../../../components/charts/BarExample.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'report-fix',
  components: {History, BarChart},
  props: [],
  data () {
    return {
      checklist_items: [],
      canvasEle: '',
      canvasPdf: '',
      status: '',
      loading: false,
      dataCharts: [],
      labels: [this.$t('checklist_fix.incomplete'), this.$t('checklist_fix.complete')],
      options: {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  computed: {
    checklist () {
      return this.$store.getters['Checklist/showChecklist']
    },
    ...mapGetters({
      data: 'Report/getDataChart'
    }),
    filterChecklistItems () {
      if (this.status === '') {
        return this.checklist_items
      }
      return this.checklist_items.filter(item => {
        return parseInt(item.status) === parseInt(this.status)
      })
    }
  },
  mounted () {
    this.loading = true
    this.$loading.start()
    Promise.all([
      this.$store.dispatch('Report/getReportFix', {checklist: {id: this.$route.params.checklist_id}}),
      this.$store.dispatch('Checklist/showChecklist', { checklist: { id: this.$route.params.checklist_id } })
    ]).then(res => {
      this.checklist_items = res[0]
      this.$loading.complete()
      this.loading = false
    }).catch(errors => {
      this.loading = false
      this.$loading.fail()
    })
  },
  filters: {
    changeStatus: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  watch: {
    data: function () {
      setTimeout(() => this.convertcavas(), 5000)
    }
  },
  methods: {
    convertcavas () {
      var resizedCanvas = document.createElement('canvas')
      var resizedContext = resizedCanvas.getContext('2d')

      resizedCanvas.height = '150'
      resizedCanvas.width = '370'

      var canvas = document.getElementById('bar_chart')
      var context = canvas.getContext('2d')

      resizedContext.drawImage(canvas, 0, 0, 370, 150)
      var myResizedData = resizedCanvas.toDataURL()
      this.canvasEle = myResizedData
    },
    _history (checklist_item = {}) {
      this.$loading.start()
      this.$store.dispatch('Audit/history', {checklist: {id: this.$route.params.checklist_id}, checklist_item}).then(res => {
        this.$refs.history.show(res)
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },
    print () {
      this.canvasPdf = document.getElementById('bar_chart').toDataURL('image/png')
      this.$nextTick(() => {
        var innerContents = document.getElementById('page').innerHTML
        var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no')
        popupWinindow.document.open()
        popupWinindow.document.write('<html><head><link rel="stylesheet" href="/static/bootstrap.css"/><link rel="stylesheet" type="text/css" href="/static/print.css" /><link rel="stylesheet" type="text/css" href="/static/style.css" /></head><body onload="window.print()">' + innerContents + '</html>')
        popupWinindow.document.close()
      })
    },
    async word (fileName) {
      var FileSaver = require('file-saver')
      var innerContents = document.getElementById('exp_word').innerHTML
      var blob = new Blob([innerContents], {type: 'application/msword;charset=utf-8'})
      FileSaver.saveAs(blob, fileName + '.doc')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist/report-fix/report-fix.js